const FROM_ADDRESS = "Vacwork <noreply@vacwork.app>";
const FROM_DEV_ADDRESS = "Vacwork <noreply@resend.dev>";

export function buildFromAddress(): string {
  return process.env.NODE_ENV === "production"
    ? FROM_ADDRESS
    : FROM_DEV_ADDRESS;
}
